import { ColDef } from "ag-grid-community";
import { RmaData } from "./rmaTypes";

const isAdmin = localStorage.getItem("isAdmin") === "true";
const isSuperAdmin = localStorage.getItem("superadmin") === "true";

const formatDateUTC3 = (date: Date | string | null): string => {
  if (!date) return "";

  const d = typeof date === "string" ? new Date(date.replace(" ", "T")) : date;

  return d.toLocaleString("en-GB", {
    timeZone: "Etc/GMT-3", // ✅ corrected
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};
const getColumnDefs = (
  handleEdit: (data: RmaData) => void,
  handleDelete: (ticketId: string) => void
): ColDef<RmaData>[] => {
  const columns: (ColDef<RmaData> | false)[] = [
    {
      field: "ticketId",
      headerName: "Ticket ID",
      filter: "agTextColumnFilter",
    },
    { field: "status", headerName: "Status", filter: "agMultiColumnFilter" },
    { field: "trackstage", headerName: "Track Stage" },
    isAdmin && {
      field: "vendorrmacross",
      headerName: "Vendor RMA Cross Reference Number",
    },
    {
      field: "ticketCreationDatetime",
      headerName: "Ticket Creation Date/Time",
      filter: "agDateColumnFilter",
      valueFormatter: (params: any) => formatDateUTC3(params.value),

      filterValueGetter: (params: any) => {
        const raw = params.data?.ticketCreationDatetime;
        return raw ? new Date(raw.replace(" ", "T")) : null;
      },
      sort: "desc",
      sortIndex: 3,
    },
    {
      field: "ticketClosureDatetime",
      headerName: "Ticket Closure Date/Time",
      filter: "agDateColumnFilter",
      valueFormatter: (params: any) => formatDateUTC3(params.value),

      filterValueGetter: (params: any) => {
        const raw = params.data?.ticketClosureDatetime;
        return raw ? new Date(raw.replace(" ", "T")) : null;
      },
    },
    { field: "affectedCustomer", headerName: "Customer" },
    { field: "affectedNetwork", headerName: " Network" },
    { field: "affectedSite", headerName: " Site" },
    {
      field: "createdby",
      headerName: "Created By",
      filter: "agMultiColumnFilter",
    },
    {
      field: "closedby",
      headerName: "Closed By",
      filter: "agMultiColumnFilter",
    },
    { field: "solution", headerName: "Solution" },

    { field: "customername", headerName: "Customer Name" },
    { field: "pointofcontact", headerName: "Point Of Contact" },
    { field: "brand", headerName: "Brand" },
    { field: "model", headerName: "Model" },
    { field: "partnumber", headerName: "Part Number" },
    { field: "serialnumber", headerName: "Serial Number" },
    { field: "password", headerName: "Password (optional)" },
    { field: "activewarranty", headerName: "Active Warranty" },
    {
      field: "faultdescription",
      headerName: " Fault Description/Analysis/Troubleshooting",
    },
    { field: "ior", headerName: "Importer of Record (IoR):" },
    { field: "companyname", headerName: "Company Name" },
    { field: "city", headerName: "City" },
    { field: "region", headerName: "Region" },
    { field: "country", headerName: "Country" },
    { field: "zip", headerName: "ZIP" },
    { field: "name", headerName: "Name" },
    { field: "email", headerName: "Email" },
    { field: "phonenumber", headerName: "Phone" },
    { field: "address1", headerName: "Address 1" },
    { field: "address2", headerName: "Address 2" },
    isAdmin && { field: "responsibleTeam", headerName: "Responsible Team" },
    isAdmin && { field: "responsiblePerson", headerName: "Responsible Person" },
    isAdmin && {
      field: "relatedobject",
      headerName: "Related Object",
      filter: "agMultiColumnFilter",
    },
    isSuperAdmin && {
      colId: "actions",
      headerName: "Actions",
      cellRenderer: (params: any) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <button onClick={() => handleEdit(params.data)}>Edit</button>(
          <button onClick={() => handleDelete(params.data.ticketId)}>
            Delete
          </button>
          )
        </div>
      ),
      pinned: "right",
      flex: 1,
    },
  ];

  return columns.filter(Boolean) as ColDef<RmaData>[];
};

export default getColumnDefs;
